export default class ToggleOpen {
    constructor() {
        this.WRAP = null;
        this.BTN = null;
        this.CONTENT = null;
        this.BLOCK_STATE = { hiddenContent: null };
    }

    /**
     * Inits instance
     * @param node {Object} - DOM node
     */
    init(node) {
        this.BTN = node;
        if (!this.BTN) throw new Error('param "node" is not passed to init method of instance');

        this.WRAP = this.BTN.closest('.js-toggle-open-wrap');
        this.CONTENT = this.WRAP.querySelector('.js-toggle-open-btn-content');

        if (this.checkOpenClass(this.BTN, 'open')) {
            this.BLOCK_STATE.hiddenContent = true;
        }

        this.BTN.addEventListener('click', this.toggleOpenClass);
    }

    /**
     * Destroys instance
     */
    destroy() {
        this.BTN.removeEventListener('click', this.toggleOpenClass);

        this.WRAP = null;
        this.BTN = null;
        this.CONTENT = null;
        this.BLOCK_STATE = { hiddenContent: null };
    }

    /**
     * Toggles 'open' class
     */
    toggleOpenClass = () => {
        if (!this.checkOpenClass(this.BTN, 'open')) {
            this.setOpenClass();
        } else {
            this.delOpenClass();
        }
    };

    /**
     * Sets 'open' class
     */
    setOpenClass() {
        this.BTN.classList.add('open');
        this.WRAP.classList.add('open');
        this.CONTENT.classList.add('open');
        this.CONTENT.dispatchEvent(new CustomEvent('content-open'));

        this.BLOCK_STATE.hiddenContent = true;
        this.BLOCK_STATE.viewMore = false;
    }

    /**
     * Removes 'del' class
     */
    delOpenClass() {
        this.BTN.classList.remove('open');
        this.WRAP.classList.remove('open');
        this.CONTENT.classList.remove('open');
        this.CONTENT.dispatchEvent(new CustomEvent('content-close'));

        this.BLOCK_STATE.hiddenContent = false;
        this.BLOCK_STATE.viewMore = false;
    }

    /**
     * Checks whether dom node has such css class
     * @param node {Object} - DOM node
     * @param cssClass {String} - css class
     * @returns {boolean}
     */
    checkOpenClass(node, cssClass) {
        return node.classList.contains(cssClass);
    }
}
